import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=8c2b0f36&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c2b0f36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c2b0f36')) {
      api.createRecord('8c2b0f36', component.options)
    } else {
      api.reload('8c2b0f36', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=8c2b0f36&scoped=true&", function () {
      api.rerender('8c2b0f36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2a5wxohQ4zPX9/JS/comp/SearchFilterTokens.vue"
export default component.exports